import { render, staticRenderFns } from "./DoctorProfileView.vue?vue&type=template&id=2894c1bc&scoped=true"
import script from "./DoctorProfileView.vue?vue&type=script&lang=js"
export * from "./DoctorProfileView.vue?vue&type=script&lang=js"
import style0 from "./DoctorProfileView.vue?vue&type=style&index=0&id=2894c1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894c1bc",
  null
  
)

export default component.exports